<script>
    export default {
        methods: {
            getFileUrl(file) {
            return URL.createObjectURL(file);
            },
            isProfilePhotoFromNetwork(file) {
                return file.profile_photo_path
            },
            isPhotoLocal(photo) {
                console.log(photo.name)
                return photo.name
            }
        }
    }
</script>